module.exports = __webpack_public_path__ + "img/private-cloud.d143e47.png";